import { writable } from "svelte/store";
export var LevelCommand;
(function (LevelCommand) {
    LevelCommand[LevelCommand["Save"] = 0] = "Save";
    LevelCommand[LevelCommand["Start"] = 1] = "Start";
})(LevelCommand || (LevelCommand = {}));
export const levelStore = writable();
